import { FilePpt } from '@phosphor-icons/react';

export default FilePpt;
